<template>
  <vs-popup class="holamundo ps-modal" title="Are you sure?" :active.sync="popupActive">
    <div class="ps-block">
      <div class="ps-title">Hi PowerSchoolers <span class="ps-title-icon">💕</span></div>
      <div class="ps-desc">Over the last 3 days, we upgraded our asset management platform to include our entire content library for you to explore. This includes creating 9,181 additional Science and Engineering Practice assets from our super-flex content engine. Hope you have fun engaging with our stuff - created with a lot of love over the past 11 years.<br><br>

<div style="text-align:left"><b style="
    color: #7367f0;
">Important Note</b>:<br>
1. This is only static content. This doesn't include our Question bank, Tests, Stereo, VR and AR (obv). The system permits a lot more configurability and extensibility - presentation on the same being shared separately.<br>
2. Each content type toggle works independently and can also be used in concert with the AMP system search.<br>
3. It's an internal tool and is web-only. <br>
4. During a load test for streaming from the US, we noticed that heavier assets experienced a higher average viewing latency of 13 seconds (peak: 42 seconds) when served from our CDN in India. Our average latency in India is 3 seconds. We are going to cache this in the US using Cloudflare, soon.
</div> <br> <b style="color: #7367f0;">Keep the questions coming!</b>
<br>We will provide you with a chatbot in a couple of days which will directly link the viewed asset to your query, allowing us to respond more quickly. <br>

</div>
      <div class="ps-btn-block">
        <vs-button class="mt-4 mr-2 shadow-lg ps-modal-btn" type="gradient" @click="() => { this.explore() }">Let's go!</vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
export default{
  props: {},
  data () {
    return {
      bodyOverflow: "",
      popupActive: false,
      isAction: false
    }
  },
  computed: {

  },
  mounted () {
    this.init()
  },
  created () {

  },
  watch: {
    popupActive() {
      if (!this.popupActive) {
        document.body.style.overflow = this.bodyOverflow;
        this.closeModal();
      } else {
        this.bodyOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
      }
    }
  },
  methods: {
    init() {
      let isPsModal = true; // localStorage.getItem("power_schoolers_modal");
      if (!isPsModal) {
        setTimeout(() => {
          this.popupActive = true;
        }, 500)
      }
    },
    closeModal() {
      setTimeout(() => {
        this.$emit('closeInfo', this.isAction);
      }, 1)
    },
    explore() {
      localStorage.setItem("power_schoolers_modal", true);
      this.popupActive = false;
      this.isAction = true;
    }
  }
}
</script>
<style lang="scss">
  .ps-modal {
    .vs-popup {
      border-radius: 12px;
    }
    .vs-popup--title {
      display: none
    }
    .vs-popup--close {
      display: none
    }
    .ps-block {
      padding: 15px;
    }
    .ps-title {
      font-size: 30px;
      font-weight: 500;
      line-height: 38px;
      text-align: center;
      margin-bottom: 15px;
      color: #7367f0;
    }
    .ps-desc {
      font-size: 16px;
      font-weight: 400;
      line-height: 23px;
      text-align: left;
      margin-bottom: 15px;
    }
    .ps-btn-block {
      display: flex;
      justify-content: center;
      .vs-button--text {
        font-size: 20px;
        font-weight: 600;
        line-height: 24px;
      }
    }
    .ps-title-icon {
      margin-right: 5px;
    }
  }
</style>
